import { useState } from "react";

export const MartingaleControl = ({ currentMartingale, loading, onSetMartingale }) => {
    const [martingale, setMartingale] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        await onSetMartingale(martingale);
        setMartingale('');
    };

    return (
        <div className="bg-slate-800 p-3 rounded-lg border border-slate-700">
            <h2 className="text-sm font-semibold text-white mb-2">
                Martingale
            </h2>

            <form onSubmit={handleSubmit}>
                <div className="mb-1.5">
                    <label className="block text-xs font-medium text-slate-300 mb-1">
                        Max Attempts
                    </label>
                    <input 
                        type="number"
                        min="1"
                        step="1"
                        placeholder="Enter max attempts" 
                        value={martingale} 
                        onChange={(e) => setMartingale(e.target.value)}
                        required
                        className="w-full h-8 px-2 text-xs bg-slate-900 text-white border border-slate-700 rounded outline-none focus:border-amber-500 focus:ring-1 focus:ring-amber-500"
                    />
                </div>
                
                <button 
                    type="submit"
                    disabled={loading}
                    className={`w-full py-1.5 text-xs font-medium text-white rounded transition-all ${
                        loading 
                            ? 'bg-gray-400 cursor-not-allowed' 
                            : 'bg-amber-500 hover:bg-amber-600 cursor-pointer'
                    }`}
                >
                    {loading ? 'Setting...' : 'Set Martingale'}
                </button>
            </form>
        </div>
    );
};
